import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { StudyLandingComponent } from './__PAGES/__LANDINGS/study-landing/study-landing.component';
import { HeaderComponent } from './__COMPONENTS/__SECTIONS/header/header.component';
import { TestimonialAComponent } from './__COMPONENTS/testimonial-a/testimonial-a.component';
import { WorkLandingComponent } from './__PAGES/__LANDINGS/work-landing/work-landing.component';
import { SectionTwoColComponent } from './__COMPONENTS/__SECTIONS/section-two-col/section-two-col.component';
import { SectionFullScreenVideoComponent } from './__COMPONENTS/__SECTIONS/section-full-screen-video/section-full-screen-video.component';
import { TestimonialCarouselComponent } from './__COMPONENTS/testimonial-carousel/testimonial-carousel.component';
import { CardTestimonialComponent } from './__COMPONENTS/card-testimonial/card-testimonial.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// MATERIAL
import {MatCardModule} from '@angular/material/card';
import {MatMenuModule} from '@angular/material/menu';
import {MatIconModule} from '@angular/material/icon';
import {MatDividerModule} from '@angular/material/divider';
import {MatListModule} from '@angular/material/list';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatTabsModule} from '@angular/material/tabs';
import {MatButtonModule} from '@angular/material/button';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatInputModule} from '@angular/material/input';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatExpansionModule} from '@angular/material/expansion';

import {MatDialogModule} from '@angular/material/dialog';

import {HttpClientModule} from '@angular/common/http';

import {MatFormFieldModule} from '@angular/material/form-field';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import { PageTitleComponent } from './__COMPONENTS/__SECTIONS/page-title/page-title.component';
import { FooterLandingComponent } from './__COMPONENTS/__common/footer-landing/footer-landing.component';
import { AccommodationLandingComponent } from './__PAGES/__LANDINGS/accommodation-landing/accommodation-landing.component';
import { FullScreenBannerAComponent } from './__COMPONENTS/full-screen-banner-a/full-screen-banner-a.component';
import { ClientBudgetComponent } from './__COMPONENTS/client-budget/client-budget.component';
import { OurOfferComponent } from './__COMPONENTS/our-offer/our-offer.component';
import { PricingPlansComponent } from './__COMPONENTS/pricing-plans/pricing-plans.component';
import { ApiConnectorService } from './_LOGIC/__api/api-connector.service';
import { PackageDetailsComponent } from './__COMPONENTS/package-details/package-details.component';
import { BookingModalComponent } from './__COMPONENTS/booking-modal/booking-modal.component';
import { PaypalButtonsComponent } from './__COMPONENTS/paypal-buttons/paypal-buttons.component';
import { VerificationModalComponent } from './__COMPONENTS/verification-modal/verification-modal.component';
import { OurTeamComponent } from './__COMPONENTS/__SECTIONS/our-team/our-team.component';
import { ShoppingCartComponent } from './__COMPONENTS/shopping-cart/shopping-cart.component';
import { WelcomeModalComponent } from './__COMPONENTS/welcome-modal/welcome-modal.component';
import { FaqPageComponent } from './__PAGES/faq-page/faq-page.component';
import { SmartHeaderComponent } from './__COMPONENTS/__SECTIONS/smart-header/smart-header.component';
import { HomePageComponent } from './__PAGES/home-page/home-page.component';
import { SectionTestimonialComponent } from './__COMPONENTS/section-testimonial/section-testimonial.component';
import { ServicesPageComponent } from './__PAGES/services-page/services-page.component';
import { PackageOfferComponent } from './__COMPONENTS/__SECTIONS/package-offer/package-offer.component';
import { ContactPageComponent } from './__PAGES/contact-page/contact-page.component';
import { SmartFooterComponent } from './__COMPONENTS/__SECTIONS/smart-footer/smart-footer.component';
import { ServiceDetailsComponent } from './__COMPONENTS/service-details/service-details.component';
import { SmartTextComponent } from './__COMPONENTS/__common/smart-text/smart-text.component';
import { TermsAndConditionsComponent } from './__PAGES/terms-and-conditions/terms-and-conditions.component';
import { PrivacyPolicyComponent } from './__PAGES/privacy-policy/privacy-policy.component';
import { WebappBannerComponent } from './__COMPONENTS/webapp-banner/webapp-banner.component';
import { WebappAdSectionComponent } from './__COMPONENTS/__SECTIONS/webapp-ad-section/webapp-ad-section.component';
import { ProductOfferComponent } from './__COMPONENTS/product-offer/product-offer.component';
import { LockedModalComponent } from './__COMPONENTS/__common/locked-modal/locked-modal.component';
import { BannerCtaFullWidthComponent } from './__COMPONENTS/__SECTIONS/banner-cta-full-width/banner-cta-full-width.component';
import { AppInitService } from './_LOGIC/__config/init.service';

export function initializeApp(appInitService: AppInitService) {
  return () => appInitService.load();
}

@NgModule({
  declarations: [
    AppComponent,
    StudyLandingComponent,
    HeaderComponent,
    TestimonialAComponent,
    WorkLandingComponent,
    SectionTwoColComponent,
    SectionFullScreenVideoComponent,
    TestimonialCarouselComponent,
    CardTestimonialComponent,
    PageTitleComponent,
    FooterLandingComponent,
    AccommodationLandingComponent,
    FullScreenBannerAComponent,
    ClientBudgetComponent,
    OurOfferComponent,
    PricingPlansComponent,
    PackageDetailsComponent,
    BookingModalComponent,
    PaypalButtonsComponent,
    VerificationModalComponent,
    LockedModalComponent,
    OurTeamComponent,
    ShoppingCartComponent,
    WelcomeModalComponent,
    FaqPageComponent,
    SmartHeaderComponent,
    HomePageComponent,
    SectionTestimonialComponent,
    SmartFooterComponent,
    ServicesPageComponent,
    PackageOfferComponent,
    ContactPageComponent,
    ServiceDetailsComponent,
    SmartTextComponent,
    TermsAndConditionsComponent,
    PrivacyPolicyComponent,
    WebappBannerComponent,
    WebappAdSectionComponent,
    ProductOfferComponent,
    BannerCtaFullWidthComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
     // MATERIAL
         // Forms
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    // Menú
    MatMenuModule,
    //
    MatInputModule,
    //Spinner
    MatProgressSpinnerModule,
    //Icon
    MatIconModule,
    // Divider
    MatDividerModule,
    // Mat List
    MatListModule,
    // Button Toggle
    MatButtonToggleModule,
        // Tabs
        MatTabsModule,
    // Button
    MatButtonModule,
    // Forms Field
    MatFormFieldModule,
    //
    MatSnackBarModule,
    //
    MatExpansionModule,
    // Http
    HttpClientModule,
    //Dialog
    MatDialogModule
  ],
  providers: [ApiConnectorService,
    AppInitService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppInitService],
      multi: true, // Ensures multiple initializers can run if needed
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
